import { Divider } from "@mui/material";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { useState } from "react";
import { findOrderGroupByIdEvent } from "../../../_events/order_list_view/find.event";
import { message } from "antd";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};


const ModalInfo = ({ orderId, orderNumber }) => {
    
    const [ open, setOpen ] = useState(false);
    const [ order, setOrder ] = useState(null);

    const loadOrder = (id) => {
        findOrderGroupByIdEvent(id)
        .then(json => {
            setOrder(json.data);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const openModal = () => {
        setOpen(true);
        loadOrder(orderId);
    }

    const closeModal = () => {
        setOpen(false);
    }

    return (
        <div>
            <span style={{ fontWeight: 'bold', margin: '0 8px', cursor: 'pointer' }}
                onClick={openModal}
            >{orderNumber}</span>
            <Modal
                open={open}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <div style={{display: 'flex', flexDirection: 'column', width: '80%'}}>
                            <strong></strong>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row-reverse', width: '20%'}}>
                            <Button size='small' onClick={closeModal}>Cerrar</Button>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Número de orden: </span>
                        <span>{order?.id}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Fecha de orden: </span>
                        <span>{order?.date_created ? `${order.date_created.split("T")[0]}` : 'Sin Fecha'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Fecha de entrega: </span>
                        <span>{order?.date_delivery ? `${order.date_delivery.split("T")[0]}` : 'INMEDIATO'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Cliente: </span>
                        <span>{order ? order.client_name : 'Sin Cliente'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Orden de compra: </span>
                        <span>{order ? order.purchase_order : 'Sin orden de compra'}</span>
                    </div>

                    <Divider />
                    {
                    order?.detailsGroup?.length === 0 ? (
                        <>No hay detalle</>
                    ) : (
                        <div style={{width: '100%', marginTop: '10px'}}>
                            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold', marginBottom:'10px'}}>Producto</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginBottom:'10px'}}>Color</div>
                                <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold', marginBottom:'10px'}}>Cantidad</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginBottom:'10px'}}>Medida</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginBottom:'10px'}}>Pendiente</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginBottom:'10px'}}>Reservado</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginBottom:'10px'}}>Despachado</div>
                            </div>
                            <Divider />
                            <div style={{width: '100%', overflowY: 'auto', height: '300px'}}>
                            {
                                
                                order?.detailsGroup?.map((d,key) => {
                                    return(
                                        <div key={key} style={ d?.deleted ? {width: '100%', backgroundColor: 'red' } : {width: '100%' }}>
                                            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                                <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold', marginTop:'10px'}}>{d?.ref}</div>
                                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginTop:'10px'}}>{d?.color }</div>
                                                <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold', marginTop:'10px'}}>{d?.quantity}</div>
                                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginTop:'10px'}}>{d?.type}</div>
                                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginTop:'10px'}}>{d?.pend}</div>
                                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginTop:'10px'}}>{d?.reser}</div>
                                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold', marginTop:'10px'}}>{d?.despa}</div>                                           
                                            </div>
                                            <Divider />
                                        </div>
                                    )
                                })
                                  
                            }
                            </div>
                        </div>
                    )
                    }
                    <Divider />
                    <Divider />
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                        <span style={{fontWeight: 'bold', marginRight: '10px'}}>Nota: </span>
                        <span>{order?.notes}</span>
                    </div>
                </Box>
            </Modal>
        </div>      
    );
}

export default ModalInfo;